import {
  AppVersion,
  Locale,
  RemoteConstantPromoCode,
  RemoteConstants,
  TripBookBanner
} from '51trips-frontend-core'
import { DocumentData, DocumentSnapshot } from 'firebase/firestore'

import { AppLanguages } from '../../constants/AppLanguages'
import appVersionConverter from './AppVersionConverter'
import remoteConstantPromoCodeConverter from './RemoteConstantPromoCodeConverter'

const remoteConstantsConverter = {
  fromFirestore: (snapshot: DocumentSnapshot<DocumentData, DocumentData>, locales: Locale[]) => {
    const data = snapshot.data()
    if (data) {
      const isCatalanLanguage = locales[0].languageCode === AppLanguages.ca
      let appStoreURL: string | undefined
      if (data.localizedAppStoreURL[locales[0].languageCode]) {
        appStoreURL = data.localizedAppStoreURL[locales[0].languageCode]
      } else {
        appStoreURL = data.localizedAppStoreURL[AppLanguages.es]
      }

      let blogURL: string | undefined
      if (data.localizedBlogURL[locales[0].languageCode]) {
        blogURL = data.localizedBlogURL[locales[0].languageCode]
      } else {
        blogURL = data.localizedBlogURL[AppLanguages.es]
      }

      let facebookURL: string | undefined
      if (data.localizedFacebookURL[locales[0].languageCode]) {
        facebookURL = data.localizedFacebookURL[locales[0].languageCode]
      } else {
        facebookURL = data.localizedFacebookURL[AppLanguages.es]
      }

      let feedbackEmail: string | undefined
      if (typeof data.feedbackEmail === 'string') {
        feedbackEmail = data.feedbackEmail
      }

      let feedbackURL: string | undefined
      if (typeof data.feedbackURL === 'string') {
        feedbackURL = data.feedbackURL
      }

      let instagramURL: string | undefined
      if (data.localizedInstagramURL[locales[0].languageCode]) {
        instagramURL = data.localizedInstagramURL[locales[0].languageCode]
      } else {
        instagramURL = data.localizedInstagramURL[AppLanguages.es]
      }

      let minimumAppVersionAndroid: AppVersion | undefined
      if (typeof data.minimumAppVersionAndroid === 'string') {
        minimumAppVersionAndroid = appVersionConverter(data.minimumAppVersionAndroid)
      }

      let minimumAppVersionIOS: AppVersion | undefined
      if (typeof data.minimumAppVersionIOS === 'string') {
        minimumAppVersionIOS = appVersionConverter(data.minimumAppVersionIOS)
      }

      let minimumAppVersionRequiredForAndroid: AppVersion | undefined
      if (typeof data.minimumAppVersionRequiredForAndroid === 'string') {
        minimumAppVersionRequiredForAndroid = appVersionConverter(
          data.minimumAppVersionRequiredForAndroid
        )
      }

      let minimumAppVersionRequiredForIOS: AppVersion | undefined
      if (typeof data.minimumAppVersionRequiredForIOS === 'string') {
        minimumAppVersionRequiredForIOS = appVersionConverter(data.minimumAppVersionRequiredForIOS)
      }

      let promoCode: RemoteConstantPromoCode | undefined
      if (data.promoCode) {
        promoCode = remoteConstantPromoCodeConverter.fromFirestore(data.promoCode)
      }

      let tripBookURL: string | undefined
      if (data.localizedTripBookURL[locales[0].languageCode]) {
        tripBookURL = data.localizedTripBookURL[locales[0].languageCode]
      } else {
        tripBookURL = data.localizedTripBookURL[AppLanguages.es]
      }

      let playStoreURL: string | undefined
      if (data.localizedPlayStoreURL[locales[0].languageCode]) {
        playStoreURL = data.localizedPlayStoreURL[locales[0].languageCode]
      } else {
        playStoreURL = data.localizedPlayStoreURL[AppLanguages.es]
      }

      let privacyPolicyURL: string | undefined
      if (data.localizedPrivacyPolicyURL[locales[0].languageCode]) {
        privacyPolicyURL = data.localizedPrivacyPolicyURL[locales[0].languageCode]
      } else {
        privacyPolicyURL = data.localizedPrivacyPolicyURL[AppLanguages.es]
      }

      let secondsRequiredPerTripBookPageGeneration: number | undefined
      if (typeof data.secondsRequiredPerTripBookPageGeneration === 'number') {
        secondsRequiredPerTripBookPageGeneration = data.secondsRequiredPerTripBookPageGeneration
      }

      let termsAndCondsURL: string | undefined
      if (data.localizedTermsAndCondsURL[locales[0].languageCode]) {
        termsAndCondsURL = data.localizedTermsAndCondsURL[locales[0].languageCode]
      } else {
        termsAndCondsURL = data.localizedTermsAndCondsURL[AppLanguages.es]
      }

      let tikTokURL: string | undefined
      if (typeof data.tikTokURL === 'string') {
        tikTokURL = data.tikTokURL
      }

      let webURL: string | undefined
      if (data.localizedWebURL[locales[0].languageCode]) {
        webURL = data.localizedWebURL[locales[0].languageCode]
      } else {
        webURL = data.localizedWebURL[AppLanguages.es]
      }

      let tripBookPreviewURL: string | undefined
      if (data.localizedTripBookPreviewURL[locales[0].languageCode]) {
        tripBookPreviewURL = data.localizedTripBookPreviewURL[locales[0].languageCode]
      } else {
        tripBookPreviewURL = data.localizedTripBookPreviewURL[AppLanguages.es]
      }

      let worldComesFirstURL: string | undefined
      if (data.localizedWorldComesFirstURL[locales[0].languageCode]) {
        worldComesFirstURL = data.localizedWorldComesFirstURL[locales[0].languageCode]
      } else {
        worldComesFirstURL = data.localizedWorldComesFirstURL[AppLanguages.es]
      }

      let imagesSupportURL: string | undefined
      if (data.localizedImagesSupportURL[locales[0].languageCode]) {
        imagesSupportURL = data.localizedImagesSupportURL[locales[0].languageCode]
      } else {
        imagesSupportURL = data.localizedImagesSupportURL[AppLanguages.en]
      }

      let supportPortalURL: string | undefined
      if (data.localizedSupportPortalURL[locales[0].languageCode]) {
        supportPortalURL = data.localizedSupportPortalURL[locales[0].languageCode]
      } else {
        supportPortalURL = data.localizedSupportPortalURL[AppLanguages.en]
      }

      let reviewUrl: string | undefined
      if (data.localizedReviewURL[locales[0].languageCode]) {
        reviewUrl = data.localizedReviewURL[locales[0].languageCode]
      } else {
        reviewUrl = data.localizedReviewURL[AppLanguages.en]
      }

      let frequentlyAskedQuestionsURL: string | undefined
      if (data.localizedFrequentlyAskedQuestionsURL[locales[0].languageCode]) {
        frequentlyAskedQuestionsURL =
          data.localizedFrequentlyAskedQuestionsURL[locales[0].languageCode]
      } else {
        frequentlyAskedQuestionsURL = data.localizedFrequentlyAskedQuestionsURL[AppLanguages.en]
      }

      let howToFillTripUrl: string | undefined
      if (data.localizedHowToFillTripURL[locales[0].languageCode]) {
        howToFillTripUrl = data.localizedHowToFillTripURL[locales[0].languageCode]
      } else if (isCatalanLanguage) {
        howToFillTripUrl = data.localizedHowToFillTripURL[AppLanguages.es]
      } else {
        howToFillTripUrl = data.localizedHowToFillTripURL[AppLanguages.en]
      }

      let howToCreateATripUrl: string | undefined
      if (data.localizedHowToCreateATripURL[locales[0].languageCode]) {
        howToCreateATripUrl = data.localizedHowToCreateATripURL[locales[0].languageCode]
      } else if (isCatalanLanguage) {
        howToCreateATripUrl = data.localizedHowToCreateATripURL[AppLanguages.es]
      } else {
        howToCreateATripUrl = data.localizedHowToCreateATripURL[AppLanguages.en]
      }

      let feedbackWhatsappUrl: string | undefined
      if (data.localizedFeedbackWhatsappUrl[locales[0].languageCode]) {
        feedbackWhatsappUrl = data.localizedFeedbackWhatsappUrl[locales[0].languageCode]
      } else {
        feedbackWhatsappUrl = data.localizedFeedbackWhatsappUrl[AppLanguages.en]
      }

      let tripBookBanner: TripBookBanner | undefined
      if (
        typeof data.tripBookBanner.actionURL === 'string' &&
        typeof data.tripBookBanner.backgroundImageURL === 'string' &&
        typeof data.tripBookBanner.isActive === 'boolean'
      ) {
        tripBookBanner = new TripBookBanner(
          data.tripBookBanner.actionURL,
          data.tripBookBanner.backgroundImageURL,
          data.tripBookBanner.isActive
        )
      }

      return new RemoteConstants(
        appStoreURL,
        blogURL,
        facebookURL,
        feedbackEmail,
        feedbackURL,
        instagramURL,
        minimumAppVersionAndroid,
        minimumAppVersionIOS,
        minimumAppVersionRequiredForAndroid,
        minimumAppVersionRequiredForIOS,
        promoCode,
        tripBookURL,
        playStoreURL,
        privacyPolicyURL,
        secondsRequiredPerTripBookPageGeneration,
        termsAndCondsURL,
        tikTokURL,
        webURL,
        tripBookPreviewURL,
        worldComesFirstURL,
        imagesSupportURL,
        supportPortalURL,
        reviewUrl,
        frequentlyAskedQuestionsURL,
        howToFillTripUrl,
        howToCreateATripUrl,
        feedbackWhatsappUrl,
        tripBookBanner
      )
    } else {
      return undefined
    }
  }
}

export default remoteConstantsConverter
